module.exports = __webpack_public_path__ + "assets/img/financial-lease.edb3d7bc.jpg";